import React from 'react';
import CircularProgressbar from 'react-circular-progressbar';
import CircularProgressbarStyles from 'react-circular-progressbar/dist/styles.css';
import { withStyles } from "@material-ui/core/styles";

export class CircularWeightBar extends React.Component {
  render() {
    const { value, max } = this.props;
    const acumulatedWeight = value / max * 100

    return (
      <CircularProgressbar
        percentage={acumulatedWeight}
        text={`${value} Kg`}
        strokeWidth={6}
        initialAnimation={true}
      />
    )
  }
}

export default withStyles(CircularProgressbarStyles)(CircularWeightBar);



// WEBPACK FOOTER //
// ./src/components/DashboardCartoneros/CircularWeightBar.js